import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { first } from 'rxjs/operators';
import { UbicacionUnidadDocumental } from '../../../core/model/ubicacion-unidad-documental';
import { AlmacenService } from '../../../core/services/almacen.service';

@Component({
  selector: 'app-ubicacion-unidades-documentales',
  templateUrl: './ubicacion-unidades-documentales.component.html',
  styleUrls: ['./ubicacion-unidades-documentales.component.css']
})
export class UbicacionUnidadesDocumentalesComponent implements OnInit {

  @Input() id: number;
  @Input() ubicacion: UbicacionUnidadDocumental;
  @Input() isExpediente = false;
  @Input() isContenedor = false;

  @Input() set hasShowLocation(isInLocation: boolean) {
    if (isInLocation && !this.ubicacion) {
      this.getRecordLocation();
    }
  }

  @Output() ubicacionChange = new EventEmitter<UbicacionUnidadDocumental>();

  isLoadingData: boolean;

  constructor(private almacenService: AlmacenService) { }

  ngOnInit() {
  }

  getRecordLocation() {

    this.isLoadingData = true;
    if (this.isExpediente) {
      this.almacenService.getUbicacionExpediente(this.id).pipe(first())
        .subscribe((data: UbicacionUnidadDocumental) => {
          this.processData(data);
        },
          error => {
            this.isLoadingData = false;
            this.ubicacion = undefined;
          });
    } else {
      this.almacenService.getUbicacionContenedor(this.id).pipe(first())
        .subscribe((data: UbicacionUnidadDocumental) => {
          this.processData(data);
        },
          error => {
            this.isLoadingData = false;
            this.ubicacion = undefined;
          });
    }
  }

  private processData(data: UbicacionUnidadDocumental) {
    this.ubicacion = data;
    this.ubicacionChange.emit(this.ubicacion);
    this.isLoadingData = false;
  }

  getTitleText() {
    if (this.isExpediente) {
      return 'expediente.recordLocation';
    }
    if (this.isContenedor) {
      return 'contenedor.containerLocation';
    }
  }

}
